import SchemaValidator from "../../../schema-validator";
import { Type } from "@sinclair/typebox";
import { OptionalOrNull } from "../../../shared-schemas";

const detectedFace = Type.Object({
	bbox: Type.Object({
		normalizedX: Type.Number(),
		normalizedY: Type.Number(),
		normalizedWidth: Type.Number(),
		normalizedHeight: Type.Number(),
	}),
	bboxRaw: Type.Object({
		x: Type.Number(),
		y: Type.Number(),
		width: Type.Number(),
		height: Type.Number(),
	}),
	score: Type.Number(),
	gestures: Type.Array(Type.String()),
	similarity: OptionalOrNull(Type.Number()),
	embedding: OptionalOrNull(Type.Array(Type.Number())),
});

const faceWorkerEvent = new SchemaValidator(
	Type.Partial(
		Type.Object({
			type: Type.String(),
			name: Type.String(),
			time: Type.Date(),
			details: Type.Object({
				topic: Type.String(),
				metadata: OptionalOrNull(
					Type.Object({
						duration: OptionalOrNull(Type.Number()),
					}),
				),
				detections: Type.Array(Type.Partial(detectedFace)),
			}),
		}),
	),
);

const detectedObject = Type.Object({
	bbox: Type.Object({
		normalizedX: Type.Number(),
		normalizedY: Type.Number(),
		normalizedWidth: Type.Number(),
		normalizedHeight: Type.Number(),
	}),
	bboxRaw: Type.Object({
		x: Type.Number(),
		y: Type.Number(),
		width: Type.Number(),
		height: Type.Number(),
	}),
	score: Type.Number(),
	name: Type.String(),
});

const objectWorkerEvent = new SchemaValidator(
	Type.Partial(
		Type.Object({
			type: Type.String(),
			name: Type.String(),
			time: Type.Date(),
			details: Type.Object({
				topic: Type.String(),
				metadata: OptionalOrNull(
					Type.Object({
						duration: OptionalOrNull(Type.Number()),
					}),
				),
				detections: Type.Array(Type.Partial(detectedObject)),
			}),
		}),
	),
);

export default {
	faceWorkerEvent,
	objectWorkerEvent,
};
